import React, { useEffect, useState } from 'react'
import { Titles } from '../../constant/PageTitle'
import { Button, Card, Descriptions, Divider, Empty, Image, Input, Pagination, Popconfirm, Select, Space, Spin, Table, Tag, Tooltip, } from 'antd'
import '../../style/page.css'
import { CheckCheckIcon, EyeIcon, SearchIcon, TrashIcon, } from 'lucide-react';
import Tables from '../../component/Tables';
import { useDispatch, useSelector } from 'react-redux';
import { getEnquiry, setPagination, setSearchParams, setStatusFilter, setTypeFilter } from '../../feature/enquiry/enquirySlice';
import { getEnquiryStatus, getRequestStatus } from '../../constant/Constatnt';
import { Loader } from '../../utils/Loader';
import EditEnquiry from './EditEnquiry';
import EditPendingEnquiry from './EditPendingEnquiry';


function EnquiryList() {
    const dispatch = useDispatch()
    const [value, setValue] = useState("");

    const [expandedRowKey, setExpandedRowKey] = useState(null);
    const [enquiryId, setEnquiryId] = useState(null);
    const { enquiryList, isLoading, totalPage, limit, current, status, searchParams, enquiryType } = useSelector((state) => state.enquiries);

    const columns = [
        {
            title: 'School Name',
            dataIndex: 'schoolName',
            key: 'schoolName',
            ellipsis: true,
            render: (text) => text?.length > 24 ? `${text.slice(0, 24)}...` : text,

        },
        {
            title: 'No. Of Admin',
            dataIndex: 'numberOfAdmins',
            key: 'numberOfAdmins',
            ellipsis: true,


        },
        {
            title: 'No. Of Student',
            dataIndex: 'numberOfStudents',
            key: 'numberOfStudents',
            ellipsis: true,
        },
        {
            title: 'No. Of Teacher',
            dataIndex: 'numberOfTeachers',
            key: 'numberOfTeachers',
            ellipsis: true,
        },
        {
            title: 'Enquiry Type',
            dataIndex: 'enquiryType',
            key: 'enquiryType',
            ellipsis: true,
            render:
                (_, { enquiryType }) => <Tag color={enquiryType === "Website" ? "#FF9137" : "#30AFFF"} >{enquiryType}</Tag>
        },
        {
            title: 'Status',
            dataIndex: 'enquiryStatus',
            key: 'enquiryStatus',
            ellipsis: true,
            render: (_, { enquiryStatus }) => <Tag color={getEnquiryStatus(enquiryStatus)} >{enquiryStatus}</Tag>
        },
        {
            title: 'Location',
            dataIndex: 'locationName',
            key: 'locationName',
            ellipsis: true,
        },
        {
            title: 'Created At',
            dataIndex: 'addedDate',
            key: 'addedDate',
            ellipsis: true,
        },

        {
            title: 'Action',
            ellipsis: true,
            fixed: "right",
            key: 'action',
            render: (_, {
                _id,
                enquiryStatus,
                closedRemarks,
                numberOfTeachers,
                numberOfStudents,
                numberOfAdmins,
                schoolName,
                ownerEmail,
                subScriptionId,
                expiryDate, startDate,
                locationName,
                notes,
            }) => (
                <Space size="middle">
                    {enquiryStatus === "PENDING" ? <EditPendingEnquiry editData={{
                        _id, numberOfTeachers,
                        numberOfStudents,
                        numberOfAdmins,
                        schoolName,
                        locationName, notes, ownerEmail,
                        subScriptionId,
                        expiryDate, startDate,
                    }} /> : enquiryStatus === "APPROVED" ? <CheckCheckIcon color='#25B5F8' /> : <EditEnquiry editData={{ _id, enquiryStatus, closedRemarks }} />}
                </Space>
            ),
        },
    ];

    const handlePagination = (page) => {
        dispatch(setPagination(page))
    };



    useEffect(() => {
        dispatch(getEnquiry({ current, limit, searchParams, enquiryType, status })); // send params if needed
    }, [current, searchParams, enquiryType, status])

    const typesData = ["Software", "Website"].map((item) => ({
        value: item,
        label: item,
    }))

    const onExpand = (expanded, record) => {
        console.log("expanded", expanded)
        const newExpandedRowKey = expandedRowKey === record.key ? null : record.key;
        setExpandedRowKey(newExpandedRowKey);
        if (expanded == false) {
            setExpandedRowKey(!newExpandedRowKey);
        }

        setEnquiryId(record._id);
        // Access the data of the row when expand icon is clicked
        console.log("click expend", record);

    };

    useEffect(() => {
        const timer = setTimeout(() => {
            dispatch(setSearchParams(value));
        }, 1000);

        return () => clearTimeout(timer);
    }, [value]);

    function handleSearch(e) {
        setValue(e.target.value);
    }

    const handleTypes = (val) => {
        dispatch(setTypeFilter(val))
    }
    const handleStatus = (val) => {
        dispatch(setStatusFilter(val))
    }

    return (
        <section>
            <Card>
                <div className="page_title">
                    <p>{Titles.enquiry}</p>
                    <Space>
                        <Select style={{ width: 200 }} allowClear onChange={handleStatus} placeholder="Select Status" options={getRequestStatus} variant="filled" />
                        <Select style={{ width: 200 }} allowClear onChange={handleTypes} placeholder="Select Type" options={typesData} variant="filled" />
                        <Input allowClear size='large' suffix={<SearchIcon color='lightGray' size={16} />} placeholder="Search" onChange={handleSearch} variant="filled" />
                    </Space>
                </div>
            </Card>
            <div className="page_content">
                {isLoading ? <Spin fullscreen /> :
                    <Table
                        columns={columns}
                        rowKey={(record) => record._id}
                        scroll={{ x: true }}
                        id="sevice_table"
                        dataSource={enquiryList}
                        pagination={false}
                        footer={() => (
                            <div className="pagination">
                                <Pagination
                                    current={current}
                                    onChange={handlePagination}
                                    total={totalPage ? totalPage * 10 : 0}
                                />
                            </div>
                        )}
                        expandable={{
                            expandedRowKeys: [expandedRowKey == null ? enquiryId : expandedRowKey],
                            onExpand: onExpand,
                            expandedRowRender: (record) => (
                                <div className="consultation_details">
                                    <Descriptions>
                                        <Descriptions.Item label="Login Email">
                                            {record.email || "N/A"}
                                        </Descriptions.Item>
                                        <Descriptions.Item label="Login Password">
                                            {record.password || "N/A"}
                                        </Descriptions.Item>
                                        <Descriptions.Item label="Start Date">
                                            {record.startDate || "N/A"}
                                        </Descriptions.Item>
                                        <Descriptions.Item label="Expiry Date">
                                            {record.expiryDate || "N/A"}
                                        </Descriptions.Item>
                                        <Descriptions.Item label="Location">
                                            {record.locationName}
                                        </Descriptions.Item>
                                        <Descriptions.Item span={2} label="Remark">
                                            {record.progressedRemarks || record.closedRemarks || "N/A"}
                                        </Descriptions.Item>

                                        <Descriptions.Item span={3} label="Notes">
                                            {record.notes || "N/A"}
                                        </Descriptions.Item>
                                    </Descriptions>
                                    <Divider />
                                    {!record.bankDetails ? <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} /> : <Descriptions title="Bank Details">

                                        <Descriptions.Item label="Account Holder Name">
                                            {record.bankDetails?.accountHolderName}
                                        </Descriptions.Item>
                                        <Descriptions.Item label="Bank Name">
                                            {record.bankDetails?.bankName}
                                        </Descriptions.Item>
                                        <Descriptions.Item label="Account Number">
                                            {record.bankDetails?.accountNumber}
                                        </Descriptions.Item>
                                        <Descriptions.Item label="IFSC Code">
                                            {record.bankDetails?.ifscCode}
                                        </Descriptions.Item>
                                        <Descriptions.Item label="Branch Name">
                                            {record.bankDetails?.branchName}
                                        </Descriptions.Item>
                                    </Descriptions>}

                                </div>
                            ),
                        }}
                    />}
            </div>
        </section >
    )
}

export default EnquiryList